import { get, patch, post } from 'helpers/api';
import {
  getCurrentFile,
  getFileMapping,
  getImport,
  getPaths,
} from '../selectors';
import { getRecordPage, getAllRecordsSelected, getEditingRecord } from '../run_records_selectors';
import { getCurrentStep, getSelectedFileId } from '../record_table_ui_selectors';
import { camelCase } from 'lodash';

export const END_CREATING_RECORDS = 'importRequest/END_CREATING_RECORDS';
export const endCreatingRecords = () => ({
  type: END_CREATING_RECORDS
});

export const SET_RECORDS = 'importRequest/SET_RECORDS';
export const setRecords = (records, recordIds, meta, headers, importSummary) => ({
  type: SET_RECORDS,
  records,
  recordIds,
  meta,
  headers,
  importSummary
});

export const SET_IMPORT_SUMMARY = 'importRequest/SET_IMPORT_SUMMARY';
export const setImportSummary = importSummary => ({
  type: SET_IMPORT_SUMMARY,
  importSummary
});

export const START_RETRIEVE_RECORDS = 'importRequest/STAR_RETRIEVE_RECORDS';
export const startRetrieveRecords = () => ({
  type: START_RETRIEVE_RECORDS
});

export const TOGGLE_SKIP_RECORD = 'importRequest/TOGGLE_SKIP_RECORD';
export const toggleSkipRecord = recordId => ({
  type: TOGGLE_SKIP_RECORD,
  recordId
});

export const TOGGLE_SKIP_ALL_RECORDS = 'importRequest/TOGGLE_SKIP_ALL_RECORDS';
export const toggleSkipAllRecords = skip => ({
  type: TOGGLE_SKIP_ALL_RECORDS,
  skip: skip
});

export const UPDATE_RECORD_PAGE = 'importRequest/UPDATE_RECORD_PAGE';
export const updateRecordPage = page => ({
  type: UPDATE_RECORD_PAGE,
  page
});

export const UPDATE_RECORD = 'importRequest/UPDATE_RECORD';
export const updateRecord = record => ({
  type: UPDATE_RECORD,
  record
});

export const UPDATE_EDITING_RECORD = 'importRequest/UPDATE_EDITING_RECORD';
export const updateEditingRecord = record => ({
  type: UPDATE_EDITING_RECORD,
  record
});

export const START_UPDATE_RECORD = 'importRequest/START_UPDATE_RECORD';
export const startUpdateRecord = (record, editRow) => ({
  type: START_UPDATE_RECORD,
  record,
  editRow
});

export const CANCEL_UPDATE_RECORD = 'importRequest/CANCEL_UPDATE_RECORD';
export const cancelUpdateRecord = () => ({
  type: CANCEL_UPDATE_RECORD
});

const failedPreviewRecord = (record, currentStep) => {
  return record.previewStatus !== 'error' && currentStep === 'preview';
};

const failedReviewRecord = (record, currentStep) => {
  return record.status !== 'failed' && currentStep === 'review';
};

export const retrieveRunRecords = () => {
  return (dispatch, getState) => {
    dispatch(startRetrieveRecords());

    const state = getState();
    const page = getRecordPage(state);
    const currentStep = getCurrentStep(state);
    const importer = getImport(state);
    const currentFile = getCurrentFile(state);

    get(
      `${importer.runPath}/run_records?file_id=${currentFile.id}`,
      { params: { page: page } }
    ).then((response) => {
      const { importSummary, meta } = response;
      const records = {};
      const recordIds = [];
      let failedRowsSorted = false;
      response.records.forEach((rec) => {
        if ((failedPreviewRecord(rec, currentStep) || failedReviewRecord(rec, currentStep)) && !failedRowsSorted) {
          failedRowsSorted = true;
          recordIds.sort();
        }

        rec.mappedFields = rec.mappedFields.map(f => camelCase(f));
        records[rec.id] = rec;
        recordIds.push(rec.id);
      });

      const headers = Object.keys(response.records[0].headerToFields);

      dispatch(setRecords(records, recordIds, meta, headers, importSummary));
    });
  };
};

export const retrieveImportSummary = () => {
  return (dispatch, getState) => {
    dispatch(startRetrieveRecords());

    const state = getState();
    const importer = getImport(state);
    const currentFile = getCurrentFile(state);

    get(`${importer.runPath}/import_summary?file_id=${currentFile.id}`).then((response) => {
      const { importSummary } = response;

      dispatch(setImportSummary(importSummary));
    });
  };
};

export const handleSkipRecord = (record) => {
  return (dispatch, getState) => {
    const skip = record.skip;
    dispatch(toggleSkipRecord(record.id));

    const state = getState();
    const paths = getPaths(state);
    const importer = getImport(state);
    const fileMapping = getFileMapping(state);

    patch(`${paths.import}/${importer.id}/runs/${fileMapping.runId}/run_records/${record.id}`, {
      runRecord: {
        skip: !skip
      }
    });
  };
};

export const handleToggleSkipAllRecords = () => {
  return (dispatch, getState) => {
    const state = getState();
    const toggleSkipAllRecordsPath = getState().paths.toggleSkipAllRecordsPath;
    const selectedFileId = getSelectedFileId(state);
    const skip = getAllRecordsSelected(state);
    dispatch(toggleSkipAllRecords(skip));
    post(`${toggleSkipAllRecordsPath}?file_id=${selectedFileId}`, {
      skip: skip
    });
  };
};

export const handleUpdateRecord = (cancelUpdate = true) => {
  return (dispatch, getState) => {
    const state = getState();
    const editingRecord = getEditingRecord(state);

    dispatch(updateRecord(editingRecord));
    const { mappedFields, headerToFields } = editingRecord;
    const fields = {};
    mappedFields.forEach(f => fields[f] = headerToFields[f]);

    const currentStep = getCurrentStep(state);
    const paths = getPaths(state);
    const importer = getImport(state);
    const fileMapping = getFileMapping(state);

    patch(`${paths.import}/${importer.id}/runs/${fileMapping.runId}/run_records/${editingRecord.id}`, {
      runRecord: {
        fieldOverride: fields
      },
      updateTarget: currentStep === 'review'
    }).then((response) => {
      const rec = { ...response.record };
      rec.mappedFields = rec.mappedFields.map(f => camelCase(f));

      dispatch(updateRecord(rec));
      if (cancelUpdate) dispatch(cancelUpdateRecord());
    });
  };
};
